import { useEffect, useState, useContext } from "react";
import { Input } from "design-react-kit";
import UploadFile from "../../Components/UploadFile";
import moment from "moment";
import { useCookies } from "react-cookie";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import { TokenContext } from "../../Components/TokenContext";

function NewService(props) {
  const apiToken = useContext(TokenContext);
  const [validation, setValidation] = useState(false);
  const [isOpen, toggleModal] = useState(false);
  const [data, setData] = useState();
  const [name, setName] = useState();
  const [description, setDescription] = useState();
  const [code, setCode] = useState();

  const sendService = () => {
    setValidation(true);

    let passedValidation = true;

    let tempData = {};

    if (!name) {
      passedValidation = false;
    } else {
      tempData["name"] = name;
    }

    if (!description) {
      passedValidation = false;
    } else {
      tempData["description"] = description;
    }

    if (!code) {
      passedValidation = false;
    } else {
      tempData["code"] = code;
    }

    if (passedValidation) {
      var dataJson = JSON.stringify(tempData);
      setData(dataJson);
      if (apiToken) {
        toggleModal(!isOpen);
      }
    }
  };

  const sendServiceApi = async () => {
    Repo.postInsertService(apiToken, data)
      .then((response) => {
        if (response.status == 200) {
          window.location.href = props.subfolder + "/servizi";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <h4>Nuovo Servizio</h4>
      <div className="card-wrapper card-space">
        <div className="card card-bg card-big roundedCustom">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-8">
                <Input
                  id="name"
                  required
                  type="text"
                  placeholder="Nome Servizio*"
                  name="Nome Servizio*"
                  onChange={(e) => setName(e.target.value)}
                  {...(validation &&
                    !name && {
                      infoText: "Il campo non può essere vuoto!",
                      className: "text-danger error_div",
                    })}
                />
              </div>
              <div className="col-lg-4">
                <Input
                  id="code"
                  required
                  type="text"
                  placeholder="Codice MyPay*"
                  name="Codice MyPay*"
                  onChange={(e) => setCode(e.target.value)}
                  {...(validation &&
                    !code && {
                      infoText: "Il campo non può essere vuoto!",
                      className: "text-danger error_div",
                    })}
                />
              </div>
              <div className="col-lg-12">
                <Input
                  id="description"
                  required
                  type="text"
                  placeholder="Descrizione*"
                  name="Descrizione*"
                  onChange={(e) => setDescription(e.target.value)}
                  {...(validation &&
                    !description && {
                      infoText: "Il campo non può essere vuoto!",
                      className: "text-danger error_div",
                    })}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row my-2">
        <div className="col-lg-12 text-right">
          <button
            type="button"
            className="btn btn-primary"
            data-toggle="tooltip"
            data-placement="top"
            onClick={() => sendService()}
            title="Conferma"
          >
            Conferma
          </button>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Inserimento nuovo servizio"
        body="Confermi di voler inserire un nuovo servizio?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendServiceApi()}
      ></ModalComponent>
    </div>
  );
}

export default NewService;
